export var breakpoints = {
    values: {
        xs: 0,
        sm: 600,
        //mobile
        md: 900,
        //ipad
        lg: 1200,
        xl: 1536
    }
};
